<template>
  <z-dialogo ref="dialogo" titulo="Enviar Pedido Whatsapp" largura="500px" persistent dividers>
    
    <template #conteudo>
      <v-row>
        <v-col class="text--primary">Esse pedido será enviado pelo WhatsApp para o fornecedor <b>{{ whatsapp.pedido?.fornecedor?.razao }}</b>. Escolha abaixo qual celular utilizar:</v-col>
        <v-col cols="12">
          <v-select
            v-model="whatsapp.instance_id"
            label="Enviar usando"
            filled
            dense
            hide-details
            :items="listasStore.whatsapp_instances"
            @change="event => $storage.set('instance_id', whatsapp.instance_id)"
          >
            <template #item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-html="item.text"></v-list-item-title>
                <v-list-item-subtitle v-html="item.number"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </template>


    <template #actions_right>
      <v-btn text @click="fechar">Cancelar</v-btn>
      <v-btn depressed color="primary" @click="enviar">Enviar</v-btn>
    </template>
  </z-dialogo>
</template>

<script setup>
import { ref, getCurrentInstance, inject } from 'vue'
import { useListasStore } from '@/app/store/pinia/listas.js';
import queryBuilder from '@/app/helpers/QueryBuilder';

const { proxy } = getCurrentInstance();
const $storage = proxy.$storage;
const listasStore = useListasStore();

const $notificacao = inject('notificacao');
const emit = defineEmits(['abrir', 'fechar'])


const dialogo = ref(null)
const data = ref('value')
const whatsapp = ref({
  instance_id: null,
  pedido: {},
})

async function carregarCelulares() {
  await listasStore.fetchListas([
    queryBuilder()
      .select('id as value','instance_name as text', 'number')
      .model('WhatsappInstance')
      .build()
  ]);
}

async function abrir(pedido) {

  if (!listasStore.whatsapp_instances || listasStore.whatsapp_instances.length === 0) {
    await carregarCelulares();
  }

  if ($storage.has('instance_id')) {
    whatsapp.value.instance_id = $storage.get('instance_id');
  }

  whatsapp.value.pedido = pedido;

  dialogo.value.abrir()
  emit('abrir')
}

function fechar() {
  dialogo.value.fechar()
  emit('fechar')
}

function enviar() {
  if (!whatsapp.value.instance_id) {
    $notificacao.error('Selecione o celular para envio do pedido.');
    return;
  }

  emit('enviar', whatsapp.value.pedido);
  fechar();
}

defineExpose({
  abrir,
  fechar
});

</script>

<style lang="scss" scoped>

</style>